export default __webpack_public_path__ + "locales/sl/DeleteProfileEverDialog.json?hash=cc64366abc95da10cae645a39d54d0a3";